export default (priceWithoutTax, salesTax) => {
    return priceWithoutTax * (1 + salesTax);
}